import { useEffect, useState } from 'react';
const Posts = () => {
    const [posts, setPosts] = useState(null); 
    const [isPending, setIsPending] = useState(true); 
    useEffect(() => {
        const fetchPosts = async () => {
            const response = await fetch('/api/posts')
            const json = await response.json()
            if (response.ok) {
              setPosts(json);
              setIsPending(false);
            }
        }
        fetchPosts();
    })
    return ( 
        <div>
            <h1>Possts</h1>
            {isPending && <h1>Loading... </h1>}
            {posts && posts.map((post) => (
                <div key={post._id}>
                   <p> { post.title }</p>
                   <p>{ post.body }</p>
                </div>
            ))}
        </div>
     );
}
 
export default Posts;